import { IsoTimestampSchema } from "./string-validation"
import { z } from "zod"

import { createPaginatedResponseSchema } from "./api"

export const AuditFiltersSchema = z
	.object({
		actorId: z.uuid().optional(),
		resourceType: z.string().optional(),
		resourceId: z.string().optional(),
		startDate: IsoTimestampSchema.optional(),
		endDate: IsoTimestampSchema.optional(),
		page: z.coerce.number().int().positive().default(1),
		limit: z.coerce.number().int().positive().max(100).default(25),
	})
	.meta({ id: "AuditFilters" })

export type AuditFilters = z.infer<typeof AuditFiltersSchema>

export const AuditLogEntrySchema = z.object({
	id: z.uuid(),
	createdAt: IsoTimestampSchema,
	actorSub: z.string(),
	actorUserId: z.uuid().nullable(),
	actorRoleKey: z.string().nullable(),
	actorFirstName: z.string().nullable(),
	actorLastName: z.string().nullable(),
	actorEmail: z.email().nullable(),
	action: z.string(),
	entityType: z.string().nullable(),
	entityId: z.string().nullable(),
	fieldName: z.string().nullable(),
	accessMode: z.string().nullable(),
	metadata: z.record(z.string(), z.unknown()),
}).meta({ id: "AuditLogEntry" })

export type AuditLogEntry = z.infer<typeof AuditLogEntrySchema>

export const AuditLogListResponseSchema = createPaginatedResponseSchema(AuditLogEntrySchema)
	.meta({ id: "AuditLogListResponse" })

export type AuditLogListResponse = z.infer<typeof AuditLogListResponseSchema>
